export const ROUTES = {
  root: "/",
  auth: "/auth",
  login: "/auth/login",
  signup: "/auth/signup",
  signupConfirmEmail: "/auth/signup/confirm-email",
  onboarding: "/onboarding",
  gettingStarted: "/getting-started",
  observations: "/observations",
  bulkEntry: "/observations/bulk-entry",
  legacyToday: "/today",
  calendar: "/calendar",
  dashboard: "/dashboard",
  cycleHistory: "/cycle-history",
  instructorSetup: "/instructor/setup",
  instructorClients: "/instructor/clients",
  instructorClient: "/instructor/clients/:clientUserId",
  instructorClientCalendar: "/instructor/clients/:clientUserId/calendar",
  instructorClientInsights: "/instructor/clients/:clientUserId/insights",
  instructorClientHistory: "/instructor/clients/:clientUserId/history",
  settings: "/settings",
  subscription: "/subscription",
  help: "/help",
  invite: "/invite/:token",
} as const;

export const getInviteRoute = (token: string) => `/invite/${token}`;

export type InstructorClientTab = "calendar" | "insights" | "history";

export const getInstructorClientRoute = (
  clientUserId: string,
  tab: InstructorClientTab = "calendar"
) => `/instructor/clients/${clientUserId}/${tab}`;

const CLIENT_TAB_ROUTE_PATTERN = /^\/instructor\/clients\/[^/]+\/(calendar|insights|history)\/?$/;

/** Which client-chart tab a pathname is on, or null when it isn't a client-chart route. */
export const getInstructorClientTabFromPath = (pathname: string): InstructorClientTab | null => {
  const match = CLIENT_TAB_ROUTE_PATTERN.exec(pathname);
  return match ? (match[1] as InstructorClientTab) : null;
};

/**
 * Personal tracking pages (and billing); instructor accounts have none and are redirected to the
 * roster.
 */
export const PERSONAL_TRACKING_ROUTES = [
  ROUTES.subscription,
  ROUTES.gettingStarted,
  ROUTES.observations,
  ROUTES.bulkEntry,
  ROUTES.legacyToday,
  ROUTES.calendar,
  ROUTES.dashboard,
  ROUTES.cycleHistory,
] as const;

export const isPersonalTrackingRoute = (pathname: string) =>
  PERSONAL_TRACKING_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`));
